<template>
  <div class="issueBar">
    <div class="title">
      <div class="blue-line"></div>
      猜您想找
      <div class="more" @click="allIssue">全部问题</div>
    </div>
    <div class="container">
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="toDetails(item)"
        >
          {{ index + 1 }}、{{ item.questionName }}
        </li>
      </ul>
      <div class="changeBtn">
        <button @click="changeData">换一换</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    allIssue() {
      this.$emit('allIssue');
    },
    toDetails(item) {
      this.$emit('toDetails', item);
    },
    changeData() {
      this.$emit('changeData');
    },
  }
}
</script>

<style lang="scss">
.issueBar {
  // width: calc(100% - 30px);
  width: calc(100% - 0px);
  background: #ffffff;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;
  .title {
    padding: 10px 0;
    font-size: 15px;
    font-weight: bold;
    .blue-line {
      margin-right: 5px;
      vertical-align: baseline;
      display: inline-block;
      width: 3px;
      height: 12px;
      border-radius: 10px;
      background-color: #3296FA;
    }
    .more {
      font-size: 13px;
      float: right;
      color: #3296FA;
    }
  }
  .container {
    font-size: 12px;
    padding: 10px;
    ul {
      li {
        margin-bottom: 5px;
        padding: 0 5px 3px 5px;
        height: 25px;
        line-height: 25px;
        border-bottom: 1px solid #EFEFF4;
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
      }
    }
  }
  .changeBtn {
    margin-top: 10px;
    text-align: center;
    button {
      background-color: #3296FA;
      outline:none;
      border: none;
      color: #ffffff;
      padding: 8px 15px;
      border-radius: 5px;
    }
    button:active {
      background-color: #70b3f5;
    }
  }
}
</style>
